document.addEventListener('click', function(event) {
    document.querySelectorAll('details[open]').forEach(function(dropdown) {
      if (!dropdown.contains(event.target)) {
        dropdown.removeAttribute('open');
      }
    });
  });
  